
import recipient from '@/http/requests/recipient'

export default {
  fetchRecipientList({ commit }, data) {
    return new Promise((resolve, reject) => {
      recipient.list(data)
        .then(response => {
          if (data.page > 1) {
            commit('UPDATE_RECIPIENT_LIST', response.data.data)
          } else {
            commit('SET_RECIPIENT_LIST', response.data.data)
          }
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  addRecipient({ commit }, data) {
    return new Promise((resolve, reject) => {
      recipient
        .store(data)
        .then(response => {
          commit('ADD_RECIPIENT', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateRecipient({ commit }, data){
    return new Promise((resolve, reject) => {
      recipient
        .update(data)
        .then(response => {
          commit('UPDATE_RECIPIENT', response.data.item)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
}
